import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';
import i18n from './plugins/vue-i18n';

import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

Amplify.configure({
    Auth: {

        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: 'eu-west-3_LEf9QvZaF',

        // REQUIRED - Amazon Cognito Region
        region: 'eu-west-3',
    }
});

Auth.configure({

    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: 'eu-west-3_LEf9QvZaF',

    // REQUIRED - Amazon Cognito Region
    region: 'eu-west-3',
});

        
//import 'vue-material/dist/theme/default.css'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    i18n,
    // eslint-disable-next-line
    render: h => h(App as any)
}).$mount('#app')
